import styles from '../SeriveContractBillingOverlayController.module.scss';

import {
  CardHeader,
  RadioGroup,
  Skeleton,
  Theme,
  useMediaQuery,
} from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from '@work4all/components/lib/dataDisplay/card';

import { ControllerPlus } from '../../../../form-plus/controller-plus';
import { useFormContextPlus } from '../../../../form-plus/use-form-context-plus';
import {
  CheckboxRadioItem,
  DateTimeInputPicker,
} from '../../../../locked-inputs';
import { ControlWrapper } from '../../../components';
import { useMaskContext } from '../../../hooks/mask-context';
import { useNumberOfDueServiceContracts } from '../hooks/use-number-of-service-contract-billing-request';
import { useServiceContractBillingContext } from '../service-contract-billing-context';
import { ServiceContractsBillingsFormValue } from '../types';

export const Containment = () => {
  const { t } = useTranslation();
  const { control, watch } =
    useFormContextPlus<ServiceContractsBillingsFormValue>();
  const mask = useMaskContext();

  const { allSelected, setAllSelected, setNumberOfServiceContractsToProcess } =
    useServiceContractBillingContext();

  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('md')
  );

  const selectedRowIds = useMemo(
    () =>
      mask.params.selectedIds?.length
        ? mask.params.selectedIds?.split(',')
        : [],
    [mask.params.selectedIds]
  );

  const dueDate = watch('dueDate');

  const [numberOfDueServiceContracts, loading] = useNumberOfDueServiceContracts(
    {
      dueDate,
    }
  );

  useEffect(() => {
    setNumberOfServiceContractsToProcess(
      allSelected ? selectedRowIds.length : numberOfDueServiceContracts
    );
  }, [
    allSelected,
    numberOfDueServiceContracts,
    selectedRowIds,
    setNumberOfServiceContractsToProcess,
  ]);

  return (
    <Card className={styles.card}>
      <CardHeader
        title={t('MASK.BILLING.CONTAINMENT')}
        className={styles.cardHeader}
      />
      <ControlWrapper columns={isMobile ? 1 : 2} className={styles.cardContent}>
        <RadioGroup defaultValue="1">
          <ControlWrapper columns={isMobile ? 1 : 2}>
            <CheckboxRadioItem
              label={t('COMMON.ALL_SELECTED')}
              caption={t('COMMON.SERVICE_CONTRACT', {
                count: selectedRowIds.length,
              })}
              value="1"
              control="radio"
              onChange={() => setAllSelected(true)}
              checked={allSelected}
            />
            <CheckboxRadioItem
              label={t('MASK.BILLING.ALL_UP_TO_DATE')}
              caption={
                loading ? (
                  <Skeleton width="7rem" height="1.25rem" />
                ) : (
                  t('COMMON.SERVICE_CONTRACT', {
                    count: numberOfDueServiceContracts,
                  })
                )
              }
              value="2"
              control="radio"
              onChange={() => setAllSelected(false)}
              checked={!allSelected}
            />
          </ControlWrapper>
        </RadioGroup>
        <ControlWrapper
          columns={isMobile ? 1 : 2}
          className={styles.cardContent}
        >
          <ControllerPlus
            control={control}
            name="dueDate"
            render={({ field }) => (
              <DateTimeInputPicker
                {...field}
                value={field.value ?? new Date()}
                dateLabel={t('COMMON.DATE')}
                clearable={false}
                withTime={false}
                disabled={allSelected}
              />
            )}
          />
        </ControlWrapper>
      </ControlWrapper>
    </Card>
  );
};
